export const linkTheme = {
    baseStyle: {
        fontFamily: 'fonts',
        textDecoration: 'underline',
    },
}
